import * as React from 'react';
import { Trans } from "react-i18next";
import { Icon } from "semantic-ui-react";

export interface ITrueFalseTagProps {
  value: boolean | string;
  verbose?: boolean;
}

const TrueFalseTag: React.FunctionComponent<ITrueFalseTagProps> = ({ value, verbose }) => {
  const val = (!!value && value !== " ");
  return <>
    {(val ? <Icon name="check circle" color="green" /> : <Icon name="circle" color="red" />)}
    {verbose && <Trans i18nKey={`general.${val}`} />}
  </>;
};

export default TrueFalseTag;
